import { render } from "./Tem027.vue?vue&type=template&id=e73d6020"
import script from "./Tem027.vue?vue&type=script&lang=js"
export * from "./Tem027.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__